import React, { useEffect, useRef, useState } from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { useLeadForm } from '../../../contexts/LeadFormContext';

const PhotoGallery = () => {
  const scrollContainerRef = useRef(null);
  const [imageErrors, setImageErrors] = useState({});
  const { openLeadForm } = useLeadForm();

  // Array de imagens de produtos
  const images = [
    // Sofás
    { id: 1, src: "/assets/image-produtos/sofas/image01.jpeg", alt: "Sofá artesanal" },
    { id: 2, src: "/assets/image-produtos/sofas/image02.jpeg", alt: "Sofá artesanal" },
    { id: 3, src: "/assets/image-produtos/sofas/image03.jpeg", alt: "Sofá artesanal" },
    { id: 4, src: "/assets/image-produtos/sofas/image04.jpeg", alt: "Sofá artesanal" },
    { id: 5, src: "/assets/image-produtos/sofas/image05.jpg", alt: "Sofá artesanal" },
    { id: 6, src: "/assets/image-produtos/sofas/image06.jpeg", alt: "Sofá artesanal" },
    { id: 7, src: "/assets/image-produtos/sofas/image07.jpg", alt: "Sofá artesanal" },
    { id: 8, src: "/assets/image-produtos/sofas/image08.jpeg", alt: "Sofá artesanal" },
    // Mesas
    { id: 9, src: "/assets/image-produtos/mesas/image01.jpg", alt: "Mesa artesanal" },
    { id: 10, src: "/assets/image-produtos/mesas/image02.jpg", alt: "Mesa artesanal" },
    { id: 11, src: "/assets/image-produtos/mesas/image03.jpg", alt: "Mesa artesanal" },
    { id: 12, src: "/assets/image-produtos/mesas/image04.jpg", alt: "Mesa artesanal" },
    // Balanços
    { id: 13, src: "/assets/image-produtos/balancos/image01.jpeg", alt: "Balanço artesanal" },
    { id: 14, src: "/assets/image-produtos/balancos/image02.jpeg", alt: "Balanço artesanal" },
    // Poltronas
    { id: 15, src: "/assets/image-produtos/poltrona/image01.jpeg", alt: "Poltrona artesanal" },
    // Espreguiçadeiras
    { id: 16, src: "/assets/image-produtos/espreguicadeiras/image01.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 17, src: "/assets/image-produtos/espreguicadeiras/image02.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 18, src: "/assets/image-produtos/espreguicadeiras/image05.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 19, src: "/assets/image-produtos/espreguicadeiras/image07.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 20, src: "/assets/image-produtos/espreguicadeiras/image08.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 21, src: "/assets/image-produtos/espreguicadeiras/image09.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 22, src: "/assets/image-produtos/espreguicadeiras/image10.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 23, src: "/assets/image-produtos/espreguicadeiras/image11.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 24, src: "/assets/image-produtos/espreguicadeiras/image13.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 25, src: "/assets/image-produtos/espreguicadeiras/image14.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 26, src: "/assets/image-produtos/espreguicadeiras/image16.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 27, src: "/assets/image-produtos/espreguicadeiras/image17.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 28, src: "/assets/image-produtos/espreguicadeiras/image18.jpeg", alt: "Espreguiçadeira artesanal" },
    { id: 29, src: "/assets/image-produtos/espreguicadeiras/image19.jpeg", alt: "Espreguiçadeira artesanal" }
  ];

  // Duplicar imagens para criar efeito infinito
  const duplicatedImages = [...images, ...images, ...images];

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.3; // Velocidade do scroll (ajuste conforme necessário)
    let animationFrameId;

    const scroll = () => {
      scrollPosition += scrollSpeed;
      container.scrollLeft = scrollPosition;

      // Reset quando chegar ao final (efeito infinito)
      const maxScroll = container.scrollWidth / 3;
      if (scrollPosition >= maxScroll) {
        scrollPosition = 0;
        container.scrollLeft = 0;
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    // Pausar scroll ao passar o mouse
    const handleMouseEnter = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };

    const handleMouseLeave = () => {
      animationFrameId = requestAnimationFrame(scroll);
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    animationFrameId = requestAnimationFrame(scroll);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <section className="py-16 bg-transparent overflow-hidden">
      {/* Section Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Nossos Trabalhos
          </h2>
          <p className="text-text-secondary text-lg md:text-xl max-w-2xl mx-auto">
            Conheça alguns dos móveis únicos que criamos para nossos clientes
          </p>
        </div>
      </div>

      {/* Photo Gallery Container - Full Width */}
      <div className="relative w-full">
        <div
          ref={scrollContainerRef}
          className="flex gap-4 overflow-x-hidden scrollbar-hide"
          style={{
            scrollBehavior: 'auto',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {duplicatedImages.map((image, index) => (
            <div
              key={`${image.id}-${index}`}
              className={`flex-shrink-0 w-80 h-96 md:w-96 md:h-[500px] rounded-2xl overflow-hidden group cursor-pointer shadow-premium bg-transparent ${
                index === 0 ? 'ml-4 sm:ml-6 lg:ml-8' : ''
              }`}
            >
              <div className="relative w-full h-full bg-transparent">
                {!imageErrors[`${image.id}-${index}`] ? (
                  <Image
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    onError={() => {
                      setImageErrors(prev => ({ ...prev, [`${image.id}-${index}`]: true }));
                    }}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-transparent">
                    <span className="text-text-secondary text-sm">Imagem não disponível</span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                
                {/* Botão Falar com Consultor - aparece no hover */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                  <Button
                    variant="default"
                    size="sm"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={openLeadForm}
                    className="bg-gradient-forest text-white hover:shadow-lg transition-all duration-300 px-6 py-3 font-medium"
                  >
                    Falar com Consultor
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default PhotoGallery;
